// extracted by mini-css-extract-plugin
export default {"notes_wrapper":"AddClientNotes_notes_wrapper__NkxDY","textarea":"AddClientNotes_textarea__aoUcQ","notes_save_btn":"AddClientNotes_notes_save_btn__XpJAY"};